export const DIFF_INSERT_BG_COLOR = 'bg-success-secondary';
export const DIFF_DELETE_BG_COLOR = 'bg-error-secondary';
